function match<T extends { type: string }, R>(
  x: T,
  patterns: { [P in T['type']]: (x: T extends { type: P } ? T : never) => R },
): R {
  const matchedFunc = (patterns as any)[x.type];
  return matchedFunc && matchedFunc(x);
}

export default match;
